export default __webpack_public_path__ + "static/media/AdobeStock_126197725_x3.f2a1294f.jpg";